<div mat-dialog-title>Edit Shipping Address</div>
<div mat-dialog-content>
  <div class="shipping-address" #shippingAddress>
    <nz-skeleton [nzActive]="true"></nz-skeleton>
  </div>
</div>

<div mat-dialog-actions align="end">
  @if (data?.id) {
  <button mat-button mat-dialog-close (click)="delete()">Delete</button>
  }
  <div style="flex: 1"></div>
  <button mat-button mat-dialog-close>Cancel</button>
  <app-button type="filled" [loading]="loading" (onClick)="save()"
    >Save</app-button
  >
</div>
